import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IRavioliActionProps } from "./RavioliAction.props";

const styles = {
  primary:
    "border-primary bg-primary text-primary-foreground hover:border-primary-700 hover:bg-primary-700",
  secondary:
    "border-ink bg-surface text-foreground hover:border-primary hover:bg-collection hover:text-ink",
  ghost:
    "border-transparent border-b-primary bg-transparent px-1 text-primary hover:border-b-ink hover:text-ink",
  destructive:
    "border-selection bg-selection text-primary-foreground shadow-ravioli-ink-sm hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-none",
} as const;

export const RavioliAction = ({ action, className }: IRavioliActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "ravioli-motion-travel inline-flex min-h-11 items-center justify-center border px-5 py-3 font-ravioli-body text-[0.9375rem] font-semibold leading-5 transition-[background-color,border-color,color,box-shadow,transform] duration-200 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      {action.label}
    </Link>
  );
};

RavioliAction.displayName = "Content::RavioliAction";
